
import React from 'react';
import { Button } from '@/components/ui/button';
import { Printer } from 'lucide-react';

interface ExamTableHeaderProps {
  onPrintExam: () => void;
}

const ExamTableHeader = ({ onPrintExam }: ExamTableHeaderProps) => {
  return (
    <div className="p-4 flex justify-between items-center border-b">
      <h3 className="text-sm font-medium">Exam Results</h3>
      <Button 
        onClick={onPrintExam}
        variant="outline" 
        size="sm" 
        className="flex items-center gap-1 hover:bg-slate-100"
        aria-label="Print report"
      >
        <Printer className="h-4 w-4 mr-1" />
        Print Report
      </Button>
    </div>
  );
};

export default ExamTableHeader;
